class DeferredPass {
    /**
     * 
     * @param {Function} constructor 
     * @param {any[]} params
     */
    constructor(constructor, ...params) {
        /**
         * @type {THREE.RenderPass}
         */
        let pass = null;

        /**
         * 
         * @param {*} params 
         * @returns {Promise<THREE.ShaderPass>}
         */
        this.resolve = function (...additionalParams) {
            return new SyncPromise((resolve) => {
                if (!pass) pass = new constructor(...params.concat(additionalParams));
                resolve(pass);
            });
        }

        this.get = function () { return pass; }

        Object.freeze(this);
    }
}

export default DeferredPass;
export { DeferredPass };

class SyncPromise {
    constructor(callback) {
        const listeners = [];
        let resolvedValue = null;
        let unresolved = true;

        function resolve() { listeners.forEach(then => then(resolvedValue)); }

        function onResolve(value) {
            resolvedValue = value;
            unresolved = false;

            resolve();
        }

        callback(onResolve);

        this.then = cb => {
            listeners.push(cb);

            if (!unresolved) resolve();
        }
    }
}